import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M13.3 11.042a3.542 3.542 0 1 0-3.462-2.789l-5.08 5.08v2.709h2.708l.625-.625v-1.459H9.55l1.041-1.041v-1.459h1.459l.497-.497c.242.053.494.08.753.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M14.55 6.667a.417.417 0 1 1-.833 0 .417.417 0 0 1 .833 0Z" stroke="currentColor" />' }
  })
);